<template>
  <v-container>
    <v-card>
      <v-card-title
      :class="`${colorClassForContractType(contract.type)} subtitle-1`"
      style="height: 35px">
        <Icon
        margin="mt-n3 mr-1"
        :icon="hasTract ? 'mdi-crosshairs-gps' : 'mdi-account-arrow-right'"
        :tooltipText="hasTract ? $t('tract') : $t('fromAccount')"
        iconColor="white"/>
        <span class="mt-n3" style="width: 50%; white-space: nowrap; word-break: normal; overflow: hidden; text-overflow: ellipsis;">
          {{ hasTract ? contract.tractName : contract.fromAccountName }}
        </span>
      </v-card-title>
      <v-card-text style="overflow-y: auto; height: 150px">
        <v-container>
          <v-row>
            <v-col>
              <v-row v-for="(ci, index) in contractIconsFor(contract.type, 'contract')" :key="index" no-gutters class="ml-n3">
                <v-col cols="auto">
                  <Icon
                  :icon="ci.icon"
                  :tooltipText="$t(ci.tooltip)"
                  iconColor="black"/>
                </v-col>
                <v-col style="word-break: break-word;">
                  {{ ci.value(contract) }}
                </v-col>
              </v-row>
            </v-col>
            <v-col align="right" cols="auto" class="mr-n4">
              <SettlementsContractActions
                :contract="contract"
                :tickets="contract.tickets"
                :hideEditAndUnpostActions="hideEditAndUnpostActions"
                @unposted="$emit('unposted-tickets')"
                @edited="$emit('contract-edited')"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { contractIconsFor } from '../accounts-payable-module/ContractIcons'
import { ContractType } from '../../../utils/Enumerations'
import { colorClassForContractType } from '@/utils/componentHelpers.js'
export default {
  name: 'RateVerificationContractCard',

  components: {
    Icon: () => import('@/components/helper/Icon.vue'),
    SettlementsContractActions: () => import('@/components/settlements/SettlementsContractActions.vue')
  },

  props: {
    contract: {
      type: Object,
      required: true
    },
    hideEditAndUnpostActions: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters('settlements', ['currentSubModuleKey']),
    hasTract () {
      switch (this.currentSubModuleKey) {
        case 'settlementsByContract': return !!this.contract.tractName
        case 'settlementsByPayee':
        case 'byproductSettlementsByPayee':
        default:
          // TODO: IH - Include BPP after introducing tract-sourced BPP (and BP Rate Verification)
          const contractTypesWithTract = [ContractType.Production.value, ContractType.WoodsSale.value]
          return contractTypesWithTract.includes(this.contract.type)
      }
    }
  },

  methods: {
    contractIconsFor,
    colorClassForContractType
  }
}
</script>
